import { Card } from '@bancobarigui/barihaus';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { MonthlyStatusBreakdown } from '../types';
import { getStatusColor, getStatusLabel } from '../utils/chartColors';
import { EmptyState } from './EmptyState';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface MonthlyStatusBreakdownChartProps {
  data: MonthlyStatusBreakdown[];
  loading?: boolean;
}

export function MonthlyStatusBreakdownChart({ data, loading = false }: MonthlyStatusBreakdownChartProps) {
  
  const allStatuses = new Set<string>();
  data.forEach(month => {
    Object.keys(month.statusCounts).forEach(status => allStatuses.add(status));
  });
  const statusArray = Array.from(allStatuses);

  
  const datasets = statusArray.map(status => ({
    label: getStatusLabel(status),
    data: data.map(month => month.statusCounts[status] || 0),
    backgroundColor: getStatusColor(status),
    borderRadius: 4,
  }));

  const chartData = {
    labels: data.map(item => item.month),
    datasets: datasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          usePointStyle: true,
          padding: 15,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          display: true,
        },
      },
    },
  };

  const hasData = data && data.length > 0;

  return (
    <Card title="Vistorias por mês e status (evolução e composição)" bordered={false} loading={loading} style={{ height: '100%' }}>
      {!hasData ? (
        <EmptyState />
      ) : (
        <div style={{ height: '350px' }}>
          <Bar data={chartData} options={options} />
        </div>
      )}
    </Card>
  );
}
